// extracted by mini-css-extract-plugin
export default {"testimonial":"Testimonials_testimonial__61hZr"};